import { Button, Grid } from '@mantine/core'
import { useField } from '@mantine/form'
import MultiSelect from '@v2/commons/components/MultiSelect/MultiSelect.component'
import { FormikErrors } from 'formik'
import { useEffect, useMemo } from 'react'

import { Icons } from 'src/common/components/ui'
import {
  getPhoneWithMask,
  validateAndFormatPhoneNumber,
} from 'src/common/helpers'

import { openAddNewItemModal } from './AddNewItemModal/AddNewItem.component'

const OtherPhoneMultiSelect = ({
  showUpdatePerson,
  field,
  setValue,
}: {
  showUpdatePerson: boolean
  field: string[]
  setValue: (
    value: any,
    shouldValidate?: boolean,
  ) => Promise<void | FormikErrors<any>>
}) => {
  const formatPhoneNumber = (value: string) => {
    return getPhoneWithMask(validateAndFormatPhoneNumber(value))
  }
  const formField = useField({
    initialValue: field,
    onValueChange: (value: string[]) => {
      setValue(value)
    },
  })
  useEffect(() => {
    formField.setValue(field)
  }, [field])

  const dropDownOptions = useMemo(() => {
    return field.map((value: string) => ({
      value,
      label: formatPhoneNumber(value),
      disabled: showUpdatePerson,
    }))
  }, [showUpdatePerson])

  const onAddItem = (value: string) => {
    const formattedValue = validateAndFormatPhoneNumber(value)
    const newValue = [...formField.getValue(), formattedValue]
    formField.setValue(newValue)
  }

  const onChangeInputNewItem = (
    event: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => {
    const { inputType } = event.nativeEvent as InputEvent
    const { value } = event.currentTarget

    let phoneValue = value.replace(/[^0-9.]/g, '')
    if (
      inputType === 'insertFromPaste' &&
      phoneValue.length > 10 &&
      phoneValue[0] === '1'
    ) {
      phoneValue = phoneValue.substring(1)
    }

    if (phoneValue.length > 10) {
      phoneValue = phoneValue.substring(0, phoneValue.length - 1)
    }
    setValue(getPhoneWithMask(validateAndFormatPhoneNumber(phoneValue)))
  }

  const areAllOptionsSelected = () =>
    dropDownOptions.every((option) =>
      formField.getValue().includes(option.value),
    )

  const openAddNewItem = () => {
    openAddNewItemModal({
      onAddItem,
      item: 'Phone Number',
      placeholder: '888-888-8888',
      onChangeInput: onChangeInputNewItem,
    })
  }

  return (
    <MultiSelect
      label={
        <Grid align="center">
          <Grid.Col span={10} p={5}>
            Secondary Mobile Phones
          </Grid.Col>
          {!showUpdatePerson && (
            <Grid.Col span={2} pb={5} pt={5} ta="right">
              <Button
                type="button"
                mah={30}
                p={10}
                styles={{ root: { borderRadius: '4px' } }}
                onClick={openAddNewItem}
              >
                <Icons.Plus />
              </Button>
            </Grid.Col>
          )}
        </Grid>
      }
      checkIconPosition="right"
      className={!showUpdatePerson ? 'active' : 'null'}
      areSelected={showUpdatePerson || areAllOptionsSelected()}
      hidePickedOptions
      styles={{
        root: {
          width: 'calc(50% - 30px)',
          marginBottom: '25px',
        },
        label: {
          marginBottom: '10px',
          color: 'black',
          fontWeight: 'bold',
          width: '100%',
        },
        input: {
          padding: '9px',
          border: '1px solid var(--mantine-color-gray-5)',
          borderRadius: '6px',
        },
        dropdown: {
          color: 'black',
        },
      }}
      {...formField.getInputProps()}
      readOnly={showUpdatePerson}
      data={dropDownOptions}
    />
  )
}
export default OtherPhoneMultiSelect
